
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { useCursorHighlight } from './hooks/useMotion';
import { useEffect } from 'react';

function App() {
  useCursorHighlight();

  useEffect(() => {
    // Add page transition class to root container
    const root = document.getElementById('root');
    if (root && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('motion-page-transition');
    }
  }, []);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
